import { t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { STATUS_CHIP_COLOR } from "widgets/datadisplay";

export const STATUSES_ARRAY = [
  "Draft",
  "In progress",
  "Participated",
  "Completed",
  "Withdrawn",
  "Rejected"
];
export const STATUS_LABELS = {
  Draft: { key: "Draft", label: i18n._(t`Draft`) },
  "In progress": { key: "InProgress", label: i18n._(t`In progress`) },
  Participated: { key: "Participated", label: i18n._(t`Participated`) },
  Completed: { key: "Completed", label: i18n._(t`Completed`) },
  Withdrawn: { key: "Withdrawn", label: i18n._(t`Withdrawn`) },
  Rejected: { key: "Rejected", label: i18n._(t`Rejected`) },
  InProgress: { key: "InProgress", label: i18n._(t`In progress`) },
  Deactivated: { key: "Deactivated", label: i18n._(t`With deactivated users`) }
};

export const STATUS_COLOR = {
  InProgress: STATUS_CHIP_COLOR.YELLOW,
  Completed: STATUS_CHIP_COLOR.GREEN,
  Stopped: STATUS_CHIP_COLOR.RED,
  Skipped: STATUS_CHIP_COLOR.GRAY,
  Rejected: STATUS_CHIP_COLOR.RED,
  Withdrawn: STATUS_CHIP_COLOR.RED,
  NotStarted: STATUS_CHIP_COLOR.GRAY,
  Draft: STATUS_CHIP_COLOR.GRAY,
  SentBack: STATUS_CHIP_COLOR.BLUE
};

export const FLOW_STATUS = {
  LIVE: "Live",
  DRAFT: "Draft",
  PENDING: "Pending",
  ARCHIVED: "Archived",
  DELETED: "Deleted",
  NOPERMISSION: "NoPermission",
  PENDINGFROMADMIN: "PendingFromAdmin"
};

export const RESTRICTED_NOTIFICATION_FIELDS = [
  "Slider",
  "Image",
  "Attachment",
  "SmartAttachment",
  "Reference",
  "Textarea",
  "Signature",
  "StarRating",
  "Multiselect",
  "Checkbox",
  "Checklist",
  "MultiUser",
  "RichText",
  "JSON"
];
